import { fromJS, List, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

const bigSegmentIndividualTargetUpdatesFields = {
  added: List(),
  removed: List(),
};

export type BigSegmentIndividualTargetUpdatesField = keyof typeof bigSegmentIndividualTargetUpdatesFields;

type BigSegmentIndividualTargetUpdatesProps = {
  added: List<string>;
  removed: List<string>;
};
export class BigSegmentIndividualTargetUpdates extends Record<BigSegmentIndividualTargetUpdatesProps>(
  bigSegmentIndividualTargetUpdatesFields,
) {
  updateTargetsList(field: BigSegmentIndividualTargetUpdatesField, targetKey: string) {
    return this.update(field, (f) => f.push(targetKey));
  }
  getTargetUpdateField(targetKey: string): BigSegmentIndividualTargetUpdatesField | undefined {
    if (this.added.includes(targetKey)) {
      return 'added';
    }
    if (this.removed.includes(targetKey)) {
      return 'removed';
    }
    return;
  }
  toRep() {
    return {
      included: {
        add: this.added.toArray(),
        remove: this.removed.toArray(),
      },
    };
  }
}

export function createBigSegmentIndividualTargetUpdates(
  props: CreateFunctionInput<BigSegmentIndividualTargetUpdatesProps> = {},
) {
  return props instanceof BigSegmentIndividualTargetUpdates
    ? props
    : new BigSegmentIndividualTargetUpdates(fromJS(props));
}
